import React from 'react';
import { PortfolioProduct } from '../api/API';
import { useTranslate } from '../services/translation';
import LazyImage from './LazyImage';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import '../assets/css/ProductCard.css';
import { useLanguage } from '../LanguageContext';
import { Link } from 'react-router-dom';

interface ProductCardProps {
  product: PortfolioProduct;
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const { translate } = useTranslate();
  const { language } = useLanguage();

  const cardContent = (
    <>
      <div className="product-image-container">
        <LazyImage
          alt={product.title}
          src={product.image_url}
        />

        <div className="product-overlay">
          <div className="product-links">
            {product.repo_url && (
              <a
                href={product.repo_url}
                target="_blank"
                rel="noopener noreferrer"
                className="product-link github"
                title="Repository"
                onClick={(e) => e.stopPropagation()}
              >
                <FaGithub />
              </a>
            )}

            {product.live_url && (
              <a
                href={product.live_url}
                target="_blank"
                rel="noopener noreferrer"
                className="product-link live"
                title="Live Demo"
                onClick={(e) => e.stopPropagation()}
              >
                <FaExternalLinkAlt />
              </a>
            )}
          </div>
        </div>
      </div>

      <div className="product-content">
        <h3 className="product-title white">
          {translate(product.title as any)}
        </h3>

        <p className="product-description light">
          {translate(product.description as any)}
        </p>

        {product.technologies && product.technologies.length > 0 && (
          <div className="product-technologies">
            {product.technologies.slice(0, 3).map((tech) => (
              <span key={tech} className="tech-badge">
                {tech}
              </span>
            ))}

            {product.technologies.length > 3 && (
              <span className="tech-badge more">
                +{product.technologies.length - 3}
              </span>
            )}
          </div>
        )}
      </div>
    </>
  );

  if (product.slug) {
    return (
      <Link
        to={`/${language}/products/${product.slug}`}
        className="product-card clickable"
      >
        {cardContent}
      </Link>
    );
  }

  return (
    <div className="product-card">
      {cardContent}
    </div>
  );
};

export default ProductCard;